import "./ForgotPassword.css"
import React from 'react'

function ForgotPassword() {
	return (
        <React.StrictMode>
        	<div id="ForgotPassword">
				<h1 style={{"color":"red"}}>Account Maintenance</h1>
				<p>To retrieve your password, please send your username and account-related information to b06902101@csie.ntu.edu.tw</p>
        	</div>
        </React.StrictMode>
	)
}

export default ForgotPassword;